import { NgOptimizedImage } from "@angular/common";
import { Component, computed, input } from "@angular/core";
import { DirectusTranslationPipe } from "../../../../common/pipes/directus-translation.pipe";
import { GetDirectusImagePipe } from "../../../../common/pipes/get-directus-image.pipe";
import {
    sanitizeDirectusObject,
    sanitizeDirectusRelationArray
} from "../../../../common/utils/sanitize-directus-object";
import { ItemsFundingBlock } from "../../../api/packbo/models/items-funding-block";

@Component({
    selector: "packbo-funding-block",
    templateUrl: "./funding-block.template.html",
    imports: [DirectusTranslationPipe, GetDirectusImagePipe, NgOptimizedImage]
})
export class FundingBlockComponent {
    public readonly fundingBlock = input.required<ItemsFundingBlock>();
    public readonly partners = computed(() =>
        sanitizeDirectusRelationArray(this.fundingBlock().partners_refs, "partners_id").map(sanitizeDirectusObject)
    );
}
